import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
    selector: '[appLongPress]',
    standalone: true
})
export class LongPressDirective {
    @Input() pressDuration = 500;
    @Output() longPress = new EventEmitter<TouchEvent>();

    private pressTimeout: any;

    constructor() { }


    @HostListener('touchstart', ['$event'])
    onTouchStart(event: TouchEvent) {
        this.pressTimeout = setTimeout(() => {
            this.longPress.emit(event);
        }, this.pressDuration);
    }

    @HostListener('touchend')
    @HostListener('touchmove')
    @HostListener('touchcancel')
    cancel() {
        clearTimeout(this.pressTimeout);
    }
}
